module.exports = __webpack_public_path__ + "static/img/js.468ce16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/js.png
// module id = Iz78
// module chunks = 1